import React from 'react';
import PropTypes from 'prop-types';
import PurseBalanceProvider from "context/PurseBalanceContext";
import Card from './Card.js';

import * as style from 'pages/account/CardSelection.module.css';


const CardList = ({	transitAccounts }) =>
	<section className={style.cardList}>
		{transitAccounts.map((transitAccount) =>
			 <PurseBalanceProvider
				key={`${transitAccount.subsystemAccountReference}`}
				{...{ subsystemAccountReference: transitAccount.subsystemAccountReference }}
			>
				<Card transitAccount={transitAccount} />
			</PurseBalanceProvider>
		)}
	</section>;

CardList.propTypes = {
	transitAccounts: PropTypes.array.isRequired,
};

export default CardList;
